module.exports = __webpack_public_path__ + "static/media/person_white.98e12048.svg";